"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Calendar, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhereBeautyMeetsArt() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="179755" id="gülüşünüzdeki-estetik-dokunuş" className="bg-background text-foreground relative min-h-[100vh] flex items-center justify-center overflow-hidden">
      
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/luxury_dental_clinic_hero_bg.png" alt="Lüks diş kliniği estetik arka plan" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-background/80 backdrop-blur-[2px]" />
      </div>

      
      <div ref={contentRef} className={`relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-none border border-primary/20 bg-secondary/50 text-primary text-xs sm:text-sm font-medium mb-8 tracking-[0.2em] uppercase backdrop-blur-md"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-sparkles w-4 h-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/WhereBeautyMeetsArt.tsx|sig:7iqnw8" data-ast-start="1534" data-ast-end="1566"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path><path d="M20 2v4"></path><path d="M22 4h-4"></path><circle cx="4" cy="20" r="2"></circle></svg>Dİş Hekİmİ Ayşegül İnnecİ Uzun</span>

        
        <div className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-foreground drop-shadow-sm mb-6 max-w-5xl leading-[1.1] tracking-tight font-light">
          Gülüşünüzdeki <br className="hidden md:block" />
          <span className="text-primary italic font-light">
            Estetik Dokunuş
          </span>
        </div>

        
        <p className="font-sans text-lg sm:text-xl md:text-2xl text-muted-foreground mb-12 max-w-2xl font-light tracking-wide leading-relaxed">Kayseri'nin kalbinde; modern, teknoloji ve estetikle parlayan kusursuz gülüşler.</p>

        
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-center justify-center w-full sm:w-auto">
          <Button size="lg" className="w-full sm:w-auto h-14 px-10 text-base tracking-widest rounded-none bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:bg-primary/90 transition-all duration-500 uppercase font-medium" asChild>
            <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab className="block w-full">
              Randevu Al <SafeHydrate><Calendar className="w-5 h-5 ml-2" /></SafeHydrate>
            </Link>
          </Button>

          <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-10 text-base tracking-widest rounded-none border-primary/30 text-foreground hover:bg-secondary hover:text-foreground hover:border-primary/60 backdrop-blur-sm bg-transparent transition-all duration-500 uppercase font-medium" asChild>
            <Link to="/TreatmentsPage">
              Tedavilerimizi Keşfet
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}